/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Modal, Label, Checkbox, Popup, List, Loader
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import ClarLoader from '../Loader/Loader';
import api from '../../api';
import userPic from '../../images/components/profile/profile_icon_1.png';
import closeBtn from '../../images/common/close-btn.svg';
import searchIcon from '../../images/common/search_icon.png';
import WithRouter from '../Extensions/WithRouter';

class AssigningUserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMAU: props.isOpenMAU,
      isOpen: false,
      searchKeyword: '',
      errSearch: false,
      isFocus: false,
      itemsChecked: false,
      groupPopup: false,
      group: [],
      checkValue: [],
      memberList: [],
      activeIndex: '',
      currentPage: 1,
      //totalPage: 0,
      pageSize: 20,
      isMemberListLoading: false,
      error: null,
      hasMore: false,
    };
    this.closeModal = this.closeModal.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.searchMember = this.searchMember.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleProjectMemberChange = this.handleProjectMemberChange.bind(this);
    this.handleUserCheckAll = this.handleUserCheckAll.bind(this);
    this.handleSearchMember = this.handleSearchMember.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleMemberListScroll = this.handleMemberListScroll.bind(this);
    this.renderCloseGroup = this.renderCloseGroup.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.setting_popup .table_type_3 .text', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { isOpenMAU, location } = this.props;
    const path = location.pathname ? location.pathname : location;

    if (prevProps.isOpenMAU !== isOpenMAU) {
      this.setState({
        isOpenMAU,
        checkValue: [],
        memberList: [],
        itemsChecked: false,
        groupPopup: false,
        group: [],
        currentPage: 1,
      }, () => {
        if (isOpenMAU && path.indexOf('groups') !== -1) {
          this.searchGroupMember();
        } else {
          this.searchMember();
        }
      });
    }
  }

  handleProjectMemberChange(e) {
    this.setState({
      searchKeyword: e.target.value,
    });
  }

  handleSearchMember(event) {
    const { location } = this.props;
    const path = location.pathname ? location.pathname : location;
    if (event.key === 'Enter') {
      if (event.target.value === '' || event.target.value.length < 2) {
        this.setState(
          {
            errSearch: true,
            isFocus: false,
          },
          () => {
            setTimeout(() => {
              this.setState({
                errSearch: false,
                isFocus: true,
              });
            }, 1500);
          }
        );
        return false;
      }
      this.setState(
        {
          memberList: [],
        },
        () => {
          if (path.indexOf('groups') !== -1) {
            this.searchGroupMember();
          } else {
            this.searchMember();
          }
          setTimeout(() => {
            this.setState({
              isFocus: false,
            });
          }, 1500);
        }
      );
    }
  }

  handleCheckChange(e, { value }) {
    const { checkValue } = this.state;
    let newState;

    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    this.setState({
      checkValue: newState,
    });
  }

  handleUserCheckAll() {
    const { itemsChecked, memberList } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      const num = memberList.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(i);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        itemsChecked: true,
        checkValue: unique,
      });
    }
  }

  handleFocus() {
    this.setState({
      isFocus: true,
    });
  }

  handleBlur() {
    this.setState({
      isFocus: false,
    });
  }

  handleMemberListScroll(event) {
    const {
      searchMember,
      state: {
        error, isMemberListLoading, hasMore, currentPage
      },
    } = this;

    const { scrollTop, scrollHeight, clientHeight } = event.target;

    const scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (error || isMemberListLoading || !hasMore) {
      return;
    }
    if (scrolledToBottom) {
      searchMember(currentPage + 1);
    }
  }

  onSubmit() {
    const { memberList, checkValue } = this.state;

    if (checkValue.length === 0) {
      this.setState({
        isOpen: true,
      });
      return false;
    }

    const selectedArr = memberList.filter((item, index) => {
      return checkValue.indexOf(index) > -1;
    });

    let i = 0;
    for (i; i < selectedArr.length; i++) {
      selectedArr[i].type = 'user';
    }

    this.setState({
      isOpenMAU: false,
    });
    this.props.closeModal();
    this.props.completeCallback(selectedArr);
  }

  getProfileImg(value) {
    const profileImg = `/1/users/me/profile_image/${value}`;

    let baseUrl = '//'.concat(location.hostname);
    let profileImgUrl = '';

    if (process.env.NODE_ENV === 'development') {
      baseUrl = baseUrl.concat(':3000');
    } else {
      baseUrl = location.port !== '' ? baseUrl.concat(':', location.port) : '';
    }

    profileImgUrl = profileImg !== '' ? baseUrl.concat(profileImg) : userPic;

    return profileImgUrl;
  }

  guideText = () => {
    const { translate } = this.props;
    return translate('modal.title.placeholder_name_email');
  };

  closeErrorModal() {
    this.setState({
      isOpen: false,
    });
  }

  closeModal(e) {
    if (e.target.classList[0] === 'item') {
      return;
    }
    this.setState({
      isOpenMAU: false,
    });
    this.props.closeModal();
  }

  clearSearch() {
    const { location } = this.props;
    const path = location.pathname ? location.pathname : location;

    this.setState(
      {
        searchKeyword: '',
        memberList: [],
      },
      () => {
        if (path.indexOf('groups') !== -1) {
          this.searchGroupMember();
        } else {
          this.searchMember();
        }
      }
    );
  }

  searchMember(pageNo, limit) {
    const { searchKeyword, pageSize, memberList } = this.state;
    const { members, translate } = this.props;
    const page = pageNo || 1;
    const memberPerPage = limit || pageSize;
    const memberOnly = members.filter((item) => {
      return item.type === 'user';
    });
    const newArray = [];
    let i = 0;
    for (i; i < memberOnly.length; i++) {
      newArray.push(memberOnly[i].email);
    }

    if (page !== 1) {
      this.setState({
        isMemberListLoading: true,
      });
    }

    api
      .searchMember({
        search: searchKeyword || '',
        owners: this.props.state.user.email,
        members: newArray,
        search_type: 'members',
        page,
        limit: memberPerPage,
      })
      .then((response) => {
        const nextData = response.response;
        this.setState({
          //totalCount: response.count,
          currentPage: response.pagination.current,
          //totalPage: response.pagination.pages,
          hasMore: response.pagination.next !== null,
          memberList: [...memberList, ...nextData],
          isMemberListLoading: false,
          error: null,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isMemberListLoading: false,
          error: translate('modal.error.error_load'),
        });
      });
  }

  searchGroupMember() {
    const { searchKeyword } = this.state;
    const { members } = this.props;
    const newArray = [];
    let i = 0;
    for (i; i < members.length; i++) {
      newArray.push(members[i].email);
    }

    api
      .searchGroupMember({
        search: searchKeyword || '',
        members: newArray,
        search_type: 'members',
      })
      .then((response) => {
        if (response.count === 0) return;

        this.setState({
          memberList: response.response,
        });
      });
  }

  convertToString(string) {
    if (string === 'clarityadmin@insignary.com') {
      return 'Admin';
    } if (string === 'licensemanager@insignary.com') {
      return 'Licensemanager';
    }
    return string;
  }

  /*
  divideStr(groups) {
    const groupName = groups[0];
    const groupCount = groups.length - 1;
    if (groupName.length + groupCount.toString().length > 20) {
      return `${groupName.substr(0, 16)}...(${groupCount})`;
    }
    return `${groupName}(${groupCount})`;
  }
  */

  renderGroup(id, arr) {
    this.setState({
      groupPopup: true,
      activeIndex: id,
      group: arr,
    });
  }

  renderCloseGroup() {
    this.setState({
      groupPopup: false,
      activeIndex: '',
    });
  }

  render() {
    const { location, translate } = this.props;
    const {
      searchKeyword,
      errSearch,
      isFocus,
      checkValue,
      memberList,
      itemsChecked,
      activeIndex,
      isMemberListLoading,
      error,
    } = this.state;

    const path = location.pathname ? location.pathname : location;

    if (this.props.state.user.scanConfig.isLoading) {
      return <ClarLoader />;
    }

    return (
      <Modal open={this.state.isOpenMAU} onClose={this.closeModal}>
        <div className="setting_popup_wrap">
          <div className="setting_popup applying_policy">
            <div className="popup_scroll">
              <div className="setting_popup_header">
                <h2 className="popup_name">
                  {translate('modal.title.assigning_user')}
                  <em>{this.props.projectName}</em>
                </h2>
                <a
                  className="popup_close_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap">
                  <div className="setting_popup_content">
                    <div className="search_box">
                      <span className="search_icon">
                        <img src={searchIcon} alt="" />
                      </span>
                      <input
                        type="text"
                        value={searchKeyword}
                        placeholder={this.guideText()}
                        onChange={this.handleProjectMemberChange}
                        onKeyPress={this.handleSearchMember}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                      />
                      <a
                        className="reset_icon"
                        onClick={this.clearSearch}
                        onKeyUp={this.clearSearch}
                      >
                        x
                      </a>
                      {errSearch && (
                        <Label basic color="red" pointing>
                          {translate('contents_header.message.least_two_required_to_search')}
                        </Label>
                      )}
                      {isFocus && <Label pointing>{translate('modal.title.label_name_email')}</Label>}
                    </div>
                  </div>
                  <div className="setting_popup_content">
                    <div
                      //className="table_wrap table_type_3"
                      className={cx('table_wrap table_type_3', {
                        group: path.indexOf('groups') > -1,
                        member: path.indexOf('groups') === -1,
                      })}
                    >
                      {
                        path.indexOf('groups') === -1 ? (
                          <Scrollbars
                            onScroll={this.handleMemberListScroll}
                          >
                            <table className="table table_type_3" style={{ tableLayout: 'fixed' }}>
                              <colgroup>
                                <col style={{ width: '36px' }} />
                                <col style={{ width: '180px' }} />
                                <col style={{ width: '180px' }} />
                                <col style={{ width: '' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <th>
                                    <Checkbox
                                      checked={itemsChecked}
                                      onChange={this.handleUserCheckAll}
                                    />
                                  </th>
                                  <th>{translate('modal.title.user_name')}</th>
                                  <th>{translate('modal.title.email')}</th>
                                  <th style={{ textAlign: 'center' }}>{translate('modal.title.assigned_group')}</th>
                                </tr>
                                {memberList.length !== 0
                                  ? memberList.map((item, index) => {
                                    return (
                                      <tr key={uuidv4()}>
                                        <td className="text">
                                          <Checkbox
                                            value={index}
                                            checked={checkValue.indexOf(index) > -1}
                                            onChange={this.handleCheckChange}
                                          />
                                        </td>
                                        <td className="text">
                                          <span className="user_icon">
                                            <img
                                              src={this.getProfileImg(item.id)}
                                              alt=""
                                              style={{ width: '17px', height: '17px', borderRadius: '50%' }}
                                            />
                                          </span>
                                          {item.profile}
                                        </td>
                                        <td className="strong text">
                                          {this.convertToString(item.email)}
                                        </td>
                                        <td className="strong" style={{ textAlign: 'center' }}>
                                          {
                                            item.groups.length !== 0 ? (
                                              <Popup
                                                trigger={
                                                  <span style={{ cursor: 'pointer' }}>{item.groups.length}</span>
                                                }
                                                on="click"
                                                hideOnScroll
                                                position="bottom left"
                                                open={this.state.groupPopup && activeIndex === item.id}
                                                onOpen={() => {
                                                  return this.renderGroup(item.id, item.groups);
                                                }}
                                                onClose={this.renderCloseGroup}
                                              >
                                                <List>
                                                  {this.state.group.map((list) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="group" />
                                                        <List.Content>{list}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })}
                                                </List>
                                              </Popup>
                                            ) : (
                                              <span>{item.groups.length}</span>
                                            )
                                          }
                                        </td>
                                      </tr>
                                    );
                                  })
                                  : null}
                                {error && <div className="error_log">{error}</div>}
                                {isMemberListLoading && (
                                  <Loader active={isMemberListLoading} size="small" inline="centered" />
                                )}
                              </tbody>
                            </table>
                          </Scrollbars>
                        ) : (
                          <Scrollbars>
                            <table className="table table_type_3" style={{ tableLayout: 'fixed' }}>
                              <colgroup>
                                <col style={{ width: '36px' }} />
                                <col style={{ width: '180px' }} />
                                <col style={{ width: '180px' }} />
                                <col style={{ width: '' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <th>
                                    <Checkbox
                                      checked={itemsChecked}
                                      onChange={this.handleUserCheckAll}
                                    />
                                  </th>
                                  <th>{translate('modal.title.user_name')}</th>
                                  <th>{translate('modal.title.email')}</th>
                                  <th style={{ textAlign: 'center' }}>{translate('modal.title.assigned_group')}</th>
                                </tr>
                                {memberList.length !== 0
                                  ? memberList.map((item, index) => {
                                    return (
                                      <tr key={uuidv4()}>
                                        <td className="text">
                                          <Checkbox
                                            value={index}
                                            checked={checkValue.indexOf(index) > -1}
                                            onChange={this.handleCheckChange}
                                          />
                                        </td>
                                        <td className="text">
                                          <span className="user_icon">
                                            <img
                                              src={this.getProfileImg(item.id)}
                                              alt=""
                                              style={{ width: '17px', height: '17px', borderRadius: '50%' }}
                                            />
                                          </span>
                                          {item.profile}
                                        </td>
                                        <td className="strong text">
                                          {this.convertToString(item.email)}
                                        </td>
                                        <td className="strong" style={{ textAlign: 'center' }}>
                                          {
                                            item.groups.length !== 0 ? (
                                              <Popup
                                                trigger={
                                                  <span style={{ cursor: 'pointer' }}>{item.groups.length}</span>
                                                }
                                                on="click"
                                                hideOnScroll
                                                position="bottom left"
                                                open={this.state.groupPopup && activeIndex === item.id}
                                                onOpen={() => {
                                                  return this.renderGroup(item.id, item.groups);
                                                }}
                                                onClose={this.renderCloseGroup}
                                              >
                                                <List>
                                                  {this.state.group.map((list) => {
                                                    return (
                                                      <List.Item key={uuidv4()}>
                                                        <List.Icon name="group" />
                                                        <List.Content>{list}</List.Content>
                                                      </List.Item>
                                                    );
                                                  })}
                                                </List>
                                              </Popup>
                                            ) : (
                                              <span>{item.groups.length}</span>
                                            )
                                          }
                                        </td>
                                      </tr>
                                    );
                                  })
                                  : null}
                              </tbody>
                            </table>
                          </Scrollbars>
                        )
                      }
                    </div>
                  </div>
                </div>
                <div className="setting_popup_button_wrap">
                  <a
                    className="button cencel_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {translate('modal.button.cancel')}
                  </a>
                  <a
                    className="button save_button"
                    onClick={this.onSubmit}
                    onKeyUp={this.onSubmit}
                  >
                    {translate('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal open={this.state.isOpen} onClose={this.closeErrorModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{translate('modal.title.attention')}</h2>
                <p className="text">{translate('modal.message.select_one_user')}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeErrorModal}
                    onKeyUp={this.closeErrorModal}
                  >
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(AssigningUserModal)));
